import get from 'lodash/get';

import { DEFAULT_LANG } from 'server/constants';

export default (state: object) => get(state, 'page.data.lang', DEFAULT_LANG);
